import { createContext } from "react";

const CartCountContext = createContext({});

export default CartCountContext;